import { lazy } from 'react';

export const ProfileTasksPage = lazy(() =>
  import('./ui/profile-tasks').then(({ ProfileTasks }) => ({
    default: ProfileTasks,
  }))
);
